import { fmtAmount } from '../utils';
import { ChartEmptyState } from './ChartEmptyState';

export function TopClientsList({ data = [], locale }) {
  if (!data.length) return <ChartEmptyState />;

  return (
    <div>
      {data.map((c, i) => (
        <div
          key={c.clientId}
          className="flex items-center gap-3 py-2 border-b border-slate-100 last:border-0"
        >
          <div className="text-[11px] font-mono text-slate-400 w-5 flex-shrink-0">#{i + 1}</div>
          <div className="flex-1 min-w-0">
            <div className="text-[12.5px] font-semibold text-slate-800 truncate">{c.companyName}</div>
          </div>
          <div className="text-[12.5px] font-semibold tabular-nums text-slate-800">
            {fmtAmount(c.amountEur, locale)}
          </div>
        </div>
      ))}
    </div>
  );
}

export default TopClientsList;
